import { useIsMutating, useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useIsMutationCancelled } from 'utils/helpers/reactQueryHelpers';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getFormatFeedbackFormText } from 'services/performanceReview';

import {
  setAddRevision,
  setRevisionNumber,
  setSelectedRevision,
  useGroupId,
  useRevisions,
  useSelectedRevision,
} from '../slice/meshMavenSlice';
import { RephraseTextAPIResponse, RephraseTextRequestBody } from '../types/RephraseText';
import { useAnalyzeTextMutation } from './analyzeText';

export const useRephraseTextMutation = () => {
  const dispatch = useDispatch();
  const groupId = useGroupId();
  const revisions = useRevisions();
  const selectedRevision = useSelectedRevision();
  const { mutate: analyzeText } = useAnalyzeTextMutation();
  const isMutationCancelled = useIsMutationCancelled();

  return useMutation<RephraseTextAPIResponse, { message?: string }, RephraseTextRequestBody>(
    (params) =>
      getFormatFeedbackFormText({
        ...params,
        revisionNumber: params.revisionNumber + 1,
      }),
    {
      mutationKey: [REACT_QUERY_KEYS.reviewsGenAi.rephraseText],
      onError: (error) => {
        console.log('error', error);
      },
      onSuccess: (data, params) => {
        if (isMutationCancelled([REACT_QUERY_KEYS.reviewsGenAi.rephraseText])) {
          return;
        }
        dispatch(
          setSelectedRevision({
            revision: {
              ...selectedRevision,
              isReanalyzeEnabled: false,
            },
          })
        );
        dispatch(
          setAddRevision({
            revision: {
              requestId: data.requestId,
              originalState: data.rephrasedText,
              originalStateHtml: data.rephrasedText,
              updatedState: data.rephrasedText,
              updatedStateHtml: data.rephrasedText,
              isAIFeedbackProvided: false,
              isReanalyzeEnabled: false,
              isTextLengthValid: data.rephrasedText.length >= 15,
            },
          })
        );
        dispatch(setRevisionNumber({ revisionNumber: revisions.length }));
        analyzeText({
          reviewId: params.reviewId,
          empId: params.empId,
          revisionNumber: revisions.length,
          groupId,
          feedbackText: data.rephrasedText,
        });
      },
    }
  );
};

export const useRephraseTextMutationLoading = () =>
  useIsMutating({
    mutationKey: [REACT_QUERY_KEYS.reviewsGenAi.rephraseText],
  }) > 0;
